import Dashboard from '@/views/carrier/Dashboard.vue';
import MyProfile from '@/views/carrier/MyProfile.vue';
import UsersCarrierPortal from '@/views/carrier/UsersCarrierPortal.vue';
import CarrierBrokers from '@/views/carrier/CarrierBrokers.vue';
import DispatcherConnectionsIndex from '@/views/carrier/DispatcherConnectionsIndex.vue';
import OnboardingPacket from '@/views/carrier/OnboardingPacket.vue';
import OnboardingPacketStatus from '@/views/common/OnboardingPacketStatus.vue';
import AssessmentStatus from '@/views/common/AssessmentStatus.vue';
import ClaimMyProfile from '@/views/carrier/ClaimMyProfile.vue';
import ClaimMyProfileVerification from '@/views/carrier/ClaimMyProfileVerification.vue';
import DoNotDispatchHoldingTank from '@/views/common/DoNotDispatchHoldingTank.vue';
import CarrierVerifyPhysicalAssets from '@/views/carrier/VerifyPhysicalAssetsWrapper.vue';
import CarrierConnectEld from '@/views/carrier/ConnectEld.vue';
import ELDNotListed from '@/views/carrier/ELDNotListed.vue';
import ThankYou from '@/views/carrier/ThankYou.vue';
import RateConfirmationIndex from '@/views/carrier/RateConfirmationIndex.vue';
import RateConfirmationShow from '@/views/carrier/RateConfirmationShow.vue';
import MyLoads from '@/views/loads/MyLoads.vue';
import LoadDashboard from '@/views/loads/LoadDashboard.vue';
import LoadDetail from '@/views/loads/LoadDetailShow.vue';
import Capacity from '@/views/loads/Capacity.vue';
import BookNow from '@/views/loads/BookNow.vue';
import EquipmentPage from '@/views/EquipmentPage.vue';
import Offers from '@/views/loads/Offers.vue';

//Holding Tanks
import CarrierInviteOnly from '@/components/holding-tanks/CarrierInviteOnly.vue';
import CarrierRateLimitExceeded from '@/components/holding-tanks/CarrierRateLimitExceeded.vue';
import WelcomePage from '@/views/carrier/WelcomePage.vue';

import BrokersShow from '@/views/broker/Show.vue';
import SearchResults from '@/views/broker/SearchResults.vue';
export default [
  {
    path: '/carrier',
    name: 'CarrierWelcomePage',
    component: WelcomePage,
    meta: { pageTitle: 'Welcome Page' },
  },
  {
    path: '/broker',
    name: 'Broker Dashboard',
    component: CarrierBrokers,
    meta: { pageTitle: 'Carrier Brokers' },
  },
  {
    path: '/oauth/authorizations',
    name: 'Carrier Oauth Authorizations',
    component: Dashboard,
    meta: { doesNotRequireCompletedUser: true },
  },
  {
    path: '/carrier/onboarding_packets/:id',
    name: 'Carrier Onboarding Packet',
    component: OnboardingPacket,
    meta: { pageTitle: 'Onboarding Packet' },
  },
  {
    path: '/carrier/my-profile',
    name: 'Carrier My Profile',
    component: MyProfile,
    meta: { pageTitle: 'My Profile' },
  },
  {
    path: '/carrier/claim-my-profile',
    name: 'Carrier Claim My Profile',
    component: ClaimMyProfile,
    meta: { pageTitle: 'Claim My Profile', doesNotRequireCompletedUser: true },
  },
  {
    path: '/carrier/claim-my-profile-verification',
    name: 'Carrier Claim My Profile Verification',
    component: ClaimMyProfileVerification,
    meta: { pageTitle: 'Claim My Profile', doesNotRequireCompletedUser: true },
  },
  {
    path: '/carrier/dispatcher_connections',
    name: 'Carrier Dispatcher Connections Index',
    component: DispatcherConnectionsIndex,
    meta: { pageTitle: 'Dispatcher Connections' },
  },
  {
    path: '/carrier/users',
    name: 'Carrier Users',
    component: UsersCarrierPortal,
    meta: { pageTitle: 'Carrier Users' },
  },
  {
    path: '/carrier/brokers',
    name: 'Carrier Brokers',
    component: CarrierBrokers,
    meta: { pageTitle: 'Carrier Brokers' },
  },
  {
    path: '/carrier/brokers/:id',
    name: 'Carrier Brokers Show Page',
    component: BrokersShow,
    meta: { pageTitle: 'Broker Detail' },
  },
  {
    path: '/carrier/brokers/search-results',
    name: 'Carrier Brokers Search Results',
    component: SearchResults,
    meta: { pageTitle: 'Broker Search Results' },
  },
  {
    path: '/carrier/equipment',
    name: 'ELDConnections',
    component: EquipmentPage,
    meta: { pageTitle: 'ELD Connections' },
  },
  {
    path: '/carrier/onboarding_packets/:id/verify-equipment',
    name: 'Carrier Verify Equipment',
    component: CarrierVerifyPhysicalAssets,
    meta: { pageTitle: 'Carrier Verify Equipment' },
  },
  {
    path: '/carrier/onboarding_packets/:id/connect-eld',
    name: 'Carrier Connect ELD',
    component: CarrierConnectEld,
    meta: { pageTitle: 'Carrier Connect ELD' },
  },
  {
    path: '/carrier/onboarding_packets/:id/status',
    name: 'Carrier Onboarding Packet Status',
    component: OnboardingPacketStatus,
    meta: { pageTitle: 'Onboarding Packet Status' },
  },
  {
    path: '/carrier/rules_assessment/status',
    name: 'Carrier Rules Assessment Status',
    component: AssessmentStatus,
    meta: { pageTitle: 'Rules Assessment Status' },
  },
  {
    path: '/carrier/onboarding_packets/:id/eld_not_listed',
    name: 'Carrier ELD Provider Not Listed',
    component: ELDNotListed,
    meta: { pageTitle: 'ELD Not Listed' },
  },
  {
    path: '/carrier/thank-you',
    name: 'CarrierThankYou',
    component: ThankYou,
    meta: { pageTitle: 'Thank You', doesNotRequireAuthentication: true },
  },
  {
    path: '/carrier/rate-confirmations',
    name: 'Rate Confirmations',
    component: RateConfirmationIndex,
    meta: { pageTitle: 'Rate Confirmations' },
  },
  {
    path: '/carrier/rate-confirmations/:id',
    name: 'Rate Confirmation',
    component: RateConfirmationShow,
    meta: { pageTitle: 'Rate Confirmation' },
  },
  {
    path: '/carrier/holding-tank/blocked-dispatch',
    name: 'Carrier Do Not Dispatch Holding Tank',
    component: DoNotDispatchHoldingTank,
    meta: { pageTitle: 'Held By Broker' },
  },
  {
    path: '/carrier/holding-tank/invite-only',
    name: 'CarrierInviteOnly',
    component: CarrierInviteOnly,
    meta: { pageTitle: 'Carrier Invite Only' },
  },
  {
    path: '/carrier/holding-tank/rate-limit-exceeded',
    name: 'CarrierRateLimitExceeded',
    component: CarrierRateLimitExceeded,
    meta: { pageTitle: 'Carrier Rate Limit Exceeded' },
  },
  {
    path: '/carrier/loads',
    name: 'My Loads',
    component: MyLoads,
    meta: { pageTitle: 'My Loads' },
  },
  {
    path: '/carrier/loads/:id',
    name: 'Load Detail',
    component: LoadDetail,
    meta: { pageTitle: 'Load' },
  },
  {
    path: '/carrier/load-board',
    name: 'Load Board',
    component: LoadDashboard,
    meta: { pageTitle: 'Load Board' },
  },
  {
    path: '/carrier/exchange/access',
    children: [
      {
        path: 'benefits',
        name: 'Benefits',
        component: () => import('@/views/loads/ExchangeBenefits.vue'),
      },
      {
        path: 'flow',
        component: () => import('@/views/loads/ExchangeAccessFlow.vue'),
        children: [
          {
            path: 'landing',
            name: 'Exchange Access Landing',
            component: () =>
              import('@/components/ExchangeAccess/Mobile/SectionSelector.vue'),
          },
          {
            path: 'protect-your-identity',
            name: 'Protect Your Identity Exchange',
            component: () =>
              import('@/components/ExchangeAccess/Sections/SectionIdentityVerification.vue'),
          },
          {
            path: 'connect-your-eld',
            name: 'Connect Your ELD Exchange',
            component: () =>
              import('@/components/ExchangeAccess/Sections/SectionEld.vue'),
          },
          {
            path: 'file-your-insurance',
            name: 'File Your Insurance Exchange',
            component: () =>
              import('@/components/ExchangeAccess/Sections/SectionInsurance.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/carrier/my-account',
    name: 'Account Overview',
    component: () => import('@/views/carrier/MyAccount.vue'),
    children: [
      {
        path: 'landing',
        name: 'My Account Landing',
        component: () => import('@/components/Account/AccountLanding.vue'),
      },
      {
        path: 'my-profile',
        name: 'My Profile',
        component: () => import('@/components/Account/MyProfile.vue'),
      },
      {
        path: 'users',
        name: 'Users Overview',
        component: () => import('@/components/Account/Users.vue'),
      },
      {
        path: 'dispatchers',
        name: 'Dispatchers',
        component: () => import('@/components/Account/Dispatchers.vue'),
      },
      {
        path: 'ownership',
        name: 'Ownership',
        component: () => import('@/components/Account/Ownership.vue'),
      },
      {
        path: 'contacts',
        name: 'Contacts',
        component: () => import('@/components/Account/Contacts.vue'),
      },
      {
        path: 'rate-confirmation-notifications',
        name: 'RateCon Notifications',
        component: () =>
          import('@/components/Account/RateConNotifications.vue'),
      },
      {
        path: 'capacity',
        name: 'Capacity Settings',
        component: () => import('@/components/Account/Capacity.vue'),
      },
    ],
  },
  {
    path: '/carrier/capacity',
    name: 'Capacity',
    component: Capacity,
    meta: { pageTitle: 'Capacity' },
  },
  {
    path: '/carrier/my-offers',
    name: 'Offers',
    component: Offers,
    meta: { pageTitle: 'Offers' },
  },
  {
    path: '/carrier/load-board/book-now',
    name: 'Book Now',
    component: BookNow,
    meta: { pageTitle: 'Book Now' },
  },
];
